export const placeDataFields = [
    'id',
    'displayName',
    'formattedAddress',
    'addressComponents',
    'location',
    'googleMapsURI',
    'plusCode',
    'types',
    'utcOffsetMinutes',
];
